import { ObtieneTransferencia, InsertTransferencia, ObtieneTransferenciaListado, ObtieneTieneTransferencia, UpdateTransferencia, DeleteTransferencia } from "../../../application/interactors/Transferencia";

export const ObtieneTransferenciaLogic = (selListaTransferencia: any,
    rutAlumno: number,
    idProcesoItemPago: number,
    numTransaccion: string,
    rutTitular: number,
    dvTitular: string,
    nombreTitular: string,
    idBanco: number,
    idTipoCuenta: number,
    correoTitular: string,
    montoPagado: number,
    guidHQB: string,
    idEstado: number,
    usuario: string) => {
    return ObtieneTransferencia(selListaTransferencia,
        rutAlumno,
        idProcesoItemPago,
        numTransaccion,
        rutTitular,
        dvTitular,
        nombreTitular,
        idBanco,
        idTipoCuenta,
        correoTitular,
        montoPagado,
        guidHQB,
        idEstado,
        usuario
    );
}
export const ObtieneTransferenciaListadoLogic = (selListaTransferencia: any,
    codigoNegocio: number,
    rutAlumno: number,
    codSede: number,
    codCarrera: string,
    ano: number,
    periodo: number,
    idEstado: number
) => {
    return ObtieneTransferenciaListado(selListaTransferencia,
        codigoNegocio,
        rutAlumno,
        codSede,
        codCarrera,
        ano,
        periodo,
        idEstado
    );
}
export const InsertTransferenciaLogic = (selListaTransferencia: any,
    headers: any,
    rutAlumno: number,
    idProcesoItemPago: number,
    numTransaccion: string,
    rutTitular: number,
    dvTitular: string,
    nombreTitular: string,
    idBanco: number,
    idTipoCuenta: number,
    correoTitular: string,
    montoPagado: number,
    guidHQB: string,
    idEstado: number,
    usuario: string,
    idComprobante: number) => {
    return InsertTransferencia(selListaTransferencia,
        headers,
        rutAlumno,
        idProcesoItemPago,
        numTransaccion,
        rutTitular,
        dvTitular,
        nombreTitular,
        idBanco,
        idTipoCuenta,
        correoTitular,
        montoPagado,
        guidHQB,
        idEstado,
        usuario,
        idComprobante
    );
}

export const ObtieneTieneTransferenciaLogic = (selListaTransferencia: any,
    idProceso: number,
    codigoItem: number
) => {
    return ObtieneTieneTransferencia(selListaTransferencia,
        idProceso,
        codigoItem
    );
}
export const UpdateTransferenciaLogic = (selListaTransferencia: any,
    idTransferencia: number
) => {
    return UpdateTransferencia(selListaTransferencia,
        idTransferencia
    );
}
export const DeleteTransferenciaLogic = (selListaTransferencia: any,
    idItemPago: number
) => {
    return DeleteTransferencia(selListaTransferencia,
        idItemPago
    );
}
